export const REGEX_EMAIL = /.+@.+\..+/;
